import React from 'react';
import { motion } from 'framer-motion';
import ProductGroupManagement from '../../../components/productGroups/ProductGroupManagement';
import { Category } from '@mui/icons-material';

function ProductGroups() {
  return (
    <div className="flex flex-col items-stretch space-y-6">
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex items-center"
      >
        <Category className="mr-2 text-purple-600" />
        <h1 className="text-2xl font-bold text-gray-900">Zarządzanie grupami produktów</h1>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="bg-white border border-gray-200 rounded-md p-6 shadow-sm"
      >
        <ProductGroupManagement adminMode={true} />
      </motion.div>
    </div>
  );
}

export default ProductGroups;
